<template>
    <v-container fluid>
        <!--CONTRATOS LABORALES-->
        <v-row class="px-4 py-0 my-4 mx-0">
            <span style="width: 100%;" class="section-title pa-2">Contratos Laborales</span>
            <v-col xs="12" sm="12" md="6" lg="3" xl="3" class="pa-2 mt-2">
                <IndicadorCircular
                    title="Estatus de entrega"
                    centerText="Total"
                    :items="conteosContratosLaborales.por_estado_tiempo"
                    :colorItem="['#6FD3B4','#A8E8D6']"
                    :noColorRepeat="true"
                />
            </v-col>
            <v-col xs="12" sm="12" md="6" lg="3" xl="3" class="pa-2 mt-2" >
                <IndicadorCircular
                    title="Origen corporativo"
                    centerText="Total"
                    :items="conteosContratosLaborales.por_origen"
                    :colorItem="colors"
                />
            </v-col>
            <v-col xs="12" sm="12" md="6" lg="3" xl="3" class="pa-2 mt-2">
                <IndicadorCircular
                    title="Descripción de contrato"
                    centerText="Total"
                    :items="conteosContratosLaborales.por_tipo_contrato"
                    :colorItem="['#A27BA5','#C8AFCA','#B08FB2']"
                    :noColorRepeat="true"
                />
            </v-col>
            <v-col xs="12" sm="12" md="6" lg="3" xl="3" class="pa-2 mt-2" >
                <ListadoAbogados
                    :data="conteosContratosLaborales.por_abogado"
                    title="Contratos por abogado"
                />
            </v-col>
        </v-row>
        <v-row class="ma-0">
            <v-col cols="12" class="px-6">
                <v-divider color="#8aabd8" style="opacity: 0.4;"></v-divider>
            </v-col>
        </v-row>
        <!--KITS DE BAJA-->
        <v-row class="px-4 py-0 my-4 mx-0">
            <span style="width: 100%;" class="section-title pa-2">Kit de baja</span>
            <v-col xs="12" sm="12" md="6" lg="3" xl="3" class="pa-2 mt-2" >
                <IndicadorCircular
                    title="Total de kits elaborados"
                    centerText="Total"
                    :items="conteosKitsBajas.por_tipo_baja"
                    :colorItem="['#5881DB','#9CB6EC',]"
                    :noColorRepeat="true"
                />
            </v-col>
            <v-col xs="12" sm="12" md="6" lg="3" xl="3" class="pa-2 mt-2" >
                <IndicadorCircular
                    title="Origen de kits elaborados"
                    centerText="Total"
                    :items="conteosKitsBajas.por_origen"
                    :colorItem="colors"
                />
            </v-col>
            <v-col xs="12" sm="12" md="6" lg="3" xl="3" class="pa-2 mt-2">
                <ListadoAbogados
                    :data="conteosKitsBajas.por_abogado"
                    title="Elaboración de bajas por abogado"
                />
            </v-col>
        </v-row>
        <v-row class="ma-0">
            <v-col cols="12" class="px-6">
                <v-divider color="#8aabd8" style="opacity: 0.4;"></v-divider>
            </v-col>
        </v-row>
        <!--BAJAS PROGRAMADAS-->
        <v-row class="px-4 py-0 my-4 mx-0">
            <span style="width: 100%;" class="section-title pa-2">Bajas programadas</span>
            <v-col xs="12" sm="12" md="6" lg="3" xl="3" class="pa-2 mt-2" >
                <IndicadorCircular
                    title="Resultados de desvinculación"
                    centerText="Total"
                    :items="conteosBajasProgramadas.por_resultado_desvinculacion"
                    :colorItem="['#5B8ACB','#9FBCE4']"
                    :noColorRepeat="true"
                />
            </v-col>
            <v-col xs="12" sm="12" md="6" lg="3" xl="3" class="pa-2 mt-2">
                <IndicadorCircular
                    title="Desvinculación por origen"
                    centerText="Total"
                    :items="conteosBajasProgramadas.por_origen"
                    :colorItem="colors"
                />
            </v-col>
            <v-col xs="12" sm="12" md="6" lg="3" xl="3" class="pa-2 mt-2">
                <IndicadorCircular
                    title="Porcentaje de recálculo"
                    centerText="Total"
                    :items="conteosBajasProgramadas.por_recalculo"
                    :colorItem="['#61438F','#9A84BA']"
                    :noColorRepeat="true"
                />
            </v-col>
        </v-row>
        <v-row class="ma-0">
            <v-col cols="12" class="px-6">
                <v-divider color="#8aabd8" style="opacity: 0.4;"></v-divider>
            </v-col>
        </v-row>
        <!--AUDIENCIAS DE CONCILIACIÓN-->
        <v-row class="px-4 py-0 my-4 mx-0">
            <span style="width: 100%;" class="section-title pa-2">Audiencias de conciliación</span>
            <v-col xs="12" sm="12" md="6" lg="3" xl="3" class="pa-2 mt-2" >
                <IndicadorCircular
                    title="Estatus de audiencias"
                    centerText="Total"
                    :items="conteosAudienciasConciliacion.por_estatus_audiencia"
                    :colorItem="['#4E73B8','#93AAD6','#5C83C4', '#B7C8E6']"
                    :noColorRepeat="true"
                />
            </v-col>
            <v-col xs="12" sm="12" md="6" lg="3" xl="3" class="pa-2 mt-2">
                <ListadoAbogados
                    :data="conteosAudienciasConciliacion.por_abogado"
                    title="Audiencias por abogado"
                />
            </v-col>
           
        </v-row>
        <v-row class="ma-0">
            <v-col cols="12" class="px-6">
                <v-divider color="#8aabd8" style="opacity: 0.4;"></v-divider>
            </v-col>
        </v-row>
        <!--PENSIONES ALIMENTICIAS-->
        <v-row class="px-4 py-0 my-4 mx-0">
            <span style="width: 100%;" class="section-title pa-2">Pensiones</span>
            <v-col xs="12" sm="12" md="6" lg="3" xl="3" class="pa-2 mt-2" >
                <IndicadorCircular
                    title="Pensiones por origen"
                    centerText="Total"
                    :items="conteosPensionesAlimenticias.por_origen"
                    :colorItem="colors"
                />
            </v-col>
            <v-col xs="12" sm="12" md="6" lg="3" xl="3" class="pa-2 mt-2">
                <ListadoAbogados
                    :data="conteosPensionesAlimenticias.por_abogado"
                    title="Pensiones por abogado"
                />
            </v-col>            
        </v-row>
    </v-container>
</template>

<script>
import IndicadorCircular from "@/components/dashboardIndicadores/IndicadorCircular.vue";
import ListadoAbogados from '@/components/dashboardIndicadores/ListadoAbogados.vue';
    export default {
        components:{
            IndicadorCircular,
            ListadoAbogados
        },
        props:{
            infoContratosLaborales:{
                type:Object,
                required:true
            },
            infoKitsBajas:{
                type:Object,
                required:true
            },
            infoBajasProgramadas:{
                type:Object,
                required:true
            },
            infoAudienciasConciliacion:{
                type:Object,
                required:true
            },
            infoPensionesAlimenticias:{
                type:Object,
                required:true
            }
        },
        data(){
            return{
                conteosContratosLaborales:{},
                conteosKitsBajas:{},
                conteosBajasProgramadas:{},
                conteosAudienciasConciliacion:{},
                conteosPensionesAlimenticias:{},
                resumenContratosLaborales:{},
                resumenKitsBajas:{},
                resumenBajasProgramadas:{},
                resumenAudienciasConciliacion:{},
                resumenPensionesAlimenticias:{},
                colors:[
                    '#6FD3B4',
                    '#A8E8D6', // clara (más notoria)

                    '#A27BA5',
                    '#C8AFCA', // clara (más notoria)

                    '#5881DB',
                    '#9CB6EC', // clara (más notoria)

                    '#5B8ACB',
                    '#9FBCE4', // clara (más notoria)

                    '#61438F',
                    '#9A84BA', // clara (más notoria)

                    '#4E73B8',
                    '#93AAD6', // clara (más notoria, color extra)
                ]
            }
        },
        methods:{
            formatData(){
                this.conteosContratosLaborales = this.infoContratosLaborales.conteos
                this.resumenContratosLaborales = this.infoContratosLaborales.resumen
                this.conteosKitsBajas = this.infoKitsBajas.conteos
                this.resumenKitsBajas = this.infoKitsBajas.resumen
                this.conteosBajasProgramadas = this.infoBajasProgramadas.conteos
                this.resumenBajasProgramadas = this.infoBajasProgramadas.resumen
                this.conteosAudienciasConciliacion = this.infoAudienciasConciliacion.conteos
                this.resumenAudienciasConciliacion = this.infoAudienciasConciliacion.resumen
                this.conteosPensionesAlimenticias = this.infoPensionesAlimenticias.conteos
                this.resumenPensionesAlimenticias = this.infoPensionesAlimenticias.resumen
            }
        },
        created(){
            this.formatData()
        }
    }
</script>

<style scoped >
.section-title{
    font-size: 1.125rem;
    font-weight: 600;
    line-height: 1.5rem;
    color: #1A2233;
    font-family: 'Montserrat'
}
</style>